import { render, staticRenderFns } from "./ViewPlanPermissions.vue?vue&type=template&id=aea77134&"
import script from "./ViewPlanPermissions.vue?vue&type=script&lang=js&"
export * from "./ViewPlanPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ViewPlanPermissions.vue?vue&type=style&index=0&id=aea77134&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports